import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, API } from "../../api";
import { PageHeader, Panel, Btn, Input, Select, Empty } from "../../ui";

export default function BrokersPage() {
  const [list, setList] = useState(null);
  const [show, setShow] = useState(false);
  const [f, setF] = useState({ name: "", email: "", password: "", firm: "" });
  const load = () => api.get(`${API}/users?role=broker`).then(({ data }) => setList(data));
  useEffect(() => { load(); }, []);
  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post(`${API}/users`, { name: f.name, email: f.email, password: f.password, role: "broker" });
      toast.success("Broker added");
      setShow(false); setF({ name: "", email: "", password: "", firm: "" }); load();
    } catch (err) { toast.error(err.response?.data?.detail || "Could not save"); }
  };
  return (
    <div>
      <PageHeader title="Broker Partners" subtitle="Brokers get a restricted portal and see only cases they're assigned to." action={<Btn onClick={() => setShow(true)}>+ Add broker</Btn>} />
      {show && (
        <Panel className="p-6 mb-6">
          <form onSubmit={create} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Input label="Name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
            <Input label="Email" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
            <Input label="Password" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
            <Input label="Firm" value={f.firm} onChange={(e) => setF({ ...f, firm: e.target.value })} />
            <div className="sm:col-span-2 flex justify-end gap-2"><Btn variant="ghost" type="button" onClick={() => setShow(false)}>Cancel</Btn><Btn type="submit">Save</Btn></div>
          </form>
        </Panel>
      )}
      {list === null ? <p className="text-sm text-slate-500">Loading…</p> : list.length === 0 ? <Empty title="No brokers yet" /> : (
        <Panel>
          <ul className="divide-y divide-slate-100">
            {list.map((b) => <li key={b.id} className="px-5 py-3 flex items-center justify-between"><div><p className="text-sm font-medium">{b.name}</p><p className="text-[11px] text-slate-500">{b.email}{b.broker_firm_name && ` · ${b.broker_firm_name}`}</p></div></li>)}
          </ul>
        </Panel>
      )}
    </div>
  );
}
